import React, { useEffect } from 'react';
import { EonUiSegmentedButtonGroup, EonUiSegmentedButton } from '@eon-ui/eon-ui-components-react';
import { SET_REGION_FILTER } from '../../scripts/GlobalContextProvider';
import { useGlobalRegion, useGlobalDispatch } from '../../scripts/useGlobalState';
import './index.scss';


const FilterRegion = ({ regionFilters }) => {
  const globalDispatch = useGlobalDispatch();
  const region = useGlobalRegion();
  const filterNames = ['Bundesländer', 'Landkreise & kreisfreie Städte', 'Ladestationen'];

  useEffect(() => {
    const lastConfiguredRegion = regionFilters[regionFilters.length - 1];

    if (region > lastConfiguredRegion) {
      globalDispatch({ type: SET_REGION_FILTER, payload: lastConfiguredRegion });
    }
  }, [globalDispatch, region, regionFilters]);

  return (
    <section className='filterRegion'>
      <EonUiSegmentedButtonGroup size='small'>
        {regionFilters.map((regionFilter, index) => {
          const filterName = filterNames[regionFilter];
          const activeFilter = region || 0;
          const isActive = activeFilter === regionFilter;

          return (
            <EonUiSegmentedButton
              key={`${index}${filterName}`}
              value={filterName}
              label={filterName}
              checked={isActive}
              onClick={() => globalDispatch({ type: SET_REGION_FILTER, payload: regionFilter })}
              size='small'
            />
          )
        })}
      </EonUiSegmentedButtonGroup>
    </section>
  )
};

export default React.memo(FilterRegion);